import { commonTranslationJA } from "@common/translations/ja";
import { translationsEN } from "./en";

export const translationsJA: Record<keyof typeof translationsEN, string> = {
  ...commonTranslationJA,
  'Grid Opt': 'Grid Opt',
  'Tabs': 'Tabs',
  'Datasheets': 'Datasheets',
  'Export Datasheet Format': 'Export Datasheet Format',
  'Load Datasheet Format': 'Load Datasheet Format',
  'Add New Datasheet': 'Add New Datasheet',
  'Add a tab to the datasheet': 'Add a tab to the datasheet',
  'Insert a tab': 'Add a tab to the datasheet',
  'Tab name': 'Tab Name',
  'Copy tab': 'Paste Tab',
  'Paste tab into the datasheet': 'データシートにタブを貼り付け',
  'Rename tab': 'Rename Tab',
  'Delete Tab': 'Delete Tab',
  'Add Tab': 'タブを追加',
  'Insert Tab': 'タブを挿入',
  'Are you sure you want to delete this tab?': 'Are you sure you want to delete this tab?',
  'Are you sure you want to delete this row?': 'この行を削除してもよろしいですか？',
  'Failed to get update tab': 'Failed to get update tab',
  'Field has been already added': 'Field has been already added',
  'Default Settings': 'Default Settings',
  'Multiple fields selected': '複数のフィールドが選択されました',
  multiFieldSelectionHelperText:
    '複数のフィールドが選択されているため、フィールド固有のプロパティは変更できません。書式設定オプションのみ変更できます。',
  'Tab Order': 'Tab Order',
  'Show Border': 'Show Border',
  'Show Field Type': 'Show Field Type',
  'Heading': 'Heading',
  'Display Heading': 'Display Heading',
  'Added Text': 'Added Text',
  'Help Text': 'Help Text',
  'Save As Datasheet Format': 'Save As Datasheet Format',
  'Failed to save datasheet format': 'Failed to save datasheet format',
  'Datasheet format saved successfully': 'Datasheet format saved successfully',
  'Horizontal Grid': 'Horizontal Grid',
  'Vertical Grid': 'Vertical Grid',
  'wouldYouLikeToOverwriteFormatName': 'This name has already been used, would you like to overwrite the current format being used by this name?',
  'Overwrite': 'Overwrite',
  'Configure Table': 'Configure Table',
  'New Table Datasheet': 'New Table Datasheet',
  'Open Table Datasheet': 'Open Table Datasheet',
  'New Table Row': '新しいテーブル行',
  'Failed to get update configure table': 'Failed to get update configure table',
  'Save Table Format': 'Save Table Format',
  'Save format': 'Save format',
  'Format Name': 'Format Name',
  'Delete Format': 'Delete Format',
  'Confirm delete format': 'Are you sure you want to delete format',
  'Failed to delete format': 'Failed to delete format',
  'Each sub-field needs to have a numeric value. Please enter 0 for the sub-field to not display.': 'Each sub-field needs to have a numeric value. Please enter 0 for the sub-field to not display.',
  'This number has already been used in the Order, please enter a different number': 'This number has already been used in the Order, please enter a different number',
  'Yes': 'Yes',
  'No': 'No',
  "Align Left": "Align Left",
  "Align Right": "Align Right",
  "Align Top": "Align Top",
  "Align Bottom": "Align Bottom",
  "Size Horz": "Size Horz",
  "Size Vert": "Size Vert",
  'fieldExistsInTab': 'Field already exists in this tab. Please select a field and try again.',
  'Show Grid': 'Show Grid',
  'Show Page Breaks': 'Show Page Breaks',
  'Snap to Grid': 'Snap to Grid',
  'Show/Edit Tab Order': 'Show/Edit Tab Order',
  'Show Margins': 'Show Margins',
  'FHQ': 'FHQ',
  'Tablet': 'Tablet',
  'Custom': 'Custom',
  'Reset Tab Order': 'Reset Tab Order',
  'Datasheet Printing': 'Datasheet Printing',
  'Paper format': 'Paper format',
  'Paper orientation': 'Paper orientation',
  'Print Column': 'Print Column',
  'landscape': "landscape",
  'portrait': "portrait",
  'Order Test': 'Order Test',
  'Test Results': 'Test Results',
  'Generate Letter': 'Generate Letter',
  'Failed to load UPNs': 'Failed to load UPNs',
  'StTerrProvName': 'ST/Terr/Prov Name',
  'State': 'State',
  'Recently Used Datasheet Formats': 'Recently Used Datasheet Formats',
  'Select a New Datasheet Format': 'Select a New Datasheet Format',
  'Set Current Format as the Default for this Folder': 'Set Current Format as the Default for this Folder',
  'Set Current Format as the Default': 'Set Current Format as the Default',
  'Failed to set default format': 'Failed to set default format',
  selectFolderMessage: 'Please select a folder.',
  selectFormatMessage: 'Please select datasheet format',
  selectTableFirstMessage: 'Please select a table first',
  'Format': 'フォーマット',
  'Failed to export datasheet format': 'データシート形式のエクスポートに失敗しました',
  'Import': 'Import',
  'Cancel': 'Cancel',
  'Allow import to create new fields': 'Allow import to create new fields',
  'Choose Fields to Import': 'Choose Fields to Import',
  'Import Datasheet Format': 'Import Datasheet Format',
  selectFolderAndTableFirstMessage: 'Please select a table first, then select a folder.',
  confirmOverwriteDsFormat: 'A datasheet format with this name already exists, are you sure you want to overwrite this existing datasheet format?',
  importFormatOverlay: 'Importing Format. Please wait ..........',
  confirmationMessage: 'Confirmation message',
  'Rename': '名前を変更',
  'Rename Datasheet Format': 'データシート形式の名前を変更',
  'Datasheet Name': 'データシート名',
  'This name has already been used, would you like to overwrite the current format being used by this name?': 'この名前は既に使用されています。この名前を使用している現在の形式を上書きしますか？',
  'Datasheet format renamed successfully': 'データシート形式の名前が正常に変更されました',
  'Default Table Datasheet': 'デフォルトのテーブルデータシート',
  'Set Current Report as Default': 'Set Current Report as Default',
  unsavedChangesMessage: 'Datasheet format was modified. Do you want to save the changes?',
  'Validation Error': 'Validation Error',
  'Validation failed': 'Validation failed',
  'This field is required': 'This field is required',
  datasheetLockedByOtherUser:
    'Another user is editing this datasheet.  You can view it but not change it.',
  datasheetLockedByOtherUserNamed:
    'Another user ({name}) is editing this datasheet.  You can view it but not change it.',
};